import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import type { Appointment } from '@/api/appointments/appointmentsApi.types';

export const APPOINTMENT_DEEP_LINK_PARAMETER = 'appointment';

export function useAppointmentDeepLink(
  appointments: Appointment[],
  isLoaded: boolean,
  onOpenAppointment: (appointment: Appointment) => void
) {
  const [searchParams, setSearchParams] = useSearchParams();
  const requestedAppointmentId = searchParams.get(APPOINTMENT_DEEP_LINK_PARAMETER);

  useEffect(
    function openRequestedAppointment() {
      if (requestedAppointmentId === null || isLoaded === false) {
        return;
      }
      const requestedAppointment = appointments.find(function matches(appointment) {
        return appointment.id === requestedAppointmentId;
      });
      if (requestedAppointment !== undefined) {
        onOpenAppointment(requestedAppointment);
      }
      const remainingParams = new URLSearchParams(searchParams);
      remainingParams.delete(APPOINTMENT_DEEP_LINK_PARAMETER);
      setSearchParams(remainingParams, { replace: true });
    },
    [requestedAppointmentId, isLoaded, appointments, onOpenAppointment, searchParams, setSearchParams]
  );
}
